import { render } from "./SkyTitle.vue?vue&type=template&id=057ad972&scoped=true"
const script = {}

import "./SkyTitle.vue?vue&type=style&index=0&id=057ad972&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057ad972"]])

export default __exports__